import { useEffect, useState } from "react";

// It's good practice to define constants outside the component.
// This also makes it easy to change the game duration later.
const GAME_DURATION = 60; // Or whatever you prefer

export default function Timer({ gameInProgress, handleGameOver }) {
  const [timer, setTimer] = useState(GAME_DURATION);

  useEffect(() => {
    // If the game isn't running, we don't need an interval.
    // We can also reset the timer here, ready for the next game.
    if (!gameInProgress) {
      setTimer(GAME_DURATION);
      return;
    }

    // Set up the interval when the game starts.
    const intervalId = setInterval(() => {
      setTimer((prevTime) => {
        // When the timer is about to hit zero...
        if (prevTime === 1) {
          clearInterval(intervalId); // Stop this interval.
          handleGameOver(); // Notify the parent component that time is up.
        }
        return prevTime - 1;
      });
    }, 1000);

    // The cleanup function is essential. It runs if the user quits
    // mid-game (i.e., gameInProgress becomes false) or when the component unmounts.
    return () => clearInterval(intervalId);
  }, [gameInProgress, handleGameOver]); // Correct dependencies

  return <h5>Time left: {timer}</h5>;
}
